import { map, contains, toLower } from 'ramda';
import { Node } from '../../../../common/models/common/Node';
import { IAttribute } from '../../../../common/models/attribute/IAttribute';

export const nodeContainsLower = (input: string) => (node: Node) => contains(
  toLower(input),
  toLower(node.label as string)
);

export const mapTree = (attributes: IAttribute[]) => map(({ name, id, subAttributes }) => ({
  label: name,
  value: id,
  children: map(({ name: subAttributeName, id: subAttributeId }) => ({
    label: subAttributeName,
    value: subAttributeId
  }), subAttributes)
}), attributes);
